import * as Highcharts from 'highcharts';
import { ReusableFunctions } from '../classes/reusable-functions';
import { Router } from '@angular/router';

export class HeadcountTrendsChartOptions {
    constructor(private reusableFunctions: ReusableFunctions, private router: Router) {}

    public createNewHistoricalChartOptions(
        xAxisText: string,
        yAxisText: string,
        seriesData: any[],
        drillDownUrl: string,
        hasDrilldownAccsess: boolean,
        titleData,
        isAxisClickable = true
    ): Highcharts.Options {
        if (yAxisText.toLowerCase() === 'volume') {
            yAxisText = yAxisText + ' ($)';
        }

        const _this = this;
        let navFromUrl = 'historical-trends/insights/headcount-trends';

        var chartOptions: Highcharts.Options = {
            chart: {
                spacingBottom: 8,
                spacingLeft: 0,
                marginRight: 0,
                spacingRight: 0,
                reflow: true,
                spacingTop: 10,
                height: 650,
                events: {
                    render: function () {
                        if (isAxisClickable) {
                            var xAxis = this.xAxis[0];
                            var xTicks = xAxis.ticks;
                            let tickKeys = Object.keys(xTicks);
                            let points: Highcharts.Point[] = [];
                            this.series.forEach((series) => {
                                points = points.concat(series.points);
                            });
                            try {
                                tickKeys.forEach((key, i) => {
                                    let xTick = xTicks[key];
                                    if (xTick && xTick.label) {
                                        let pointInf = points.find((point) => {
                                            return (
                                                point.name &&
                                                xTick.label.element.textContent &&
                                                point.name.toLowerCase().trim() ===
                                                    xTick.label.element.textContent
                                                        .toLowerCase()
                                                        .trim()
                                            );
                                        });

                                        var label = xTick.label.element;
                                        label.style.cursor = 'pointer';
                                        label.onclick = function (item) {
                                            let queryParams = {
                                                positionAbbv: 'All',
                                                selectedPeriod: pointInf.name,
                                                navFromUrl: navFromUrl,
                                                titleSuffix: ': All positions ' + pointInf.name,
                                            };

                                            _this.router.navigate([drillDownUrl], {
                                                queryParams: queryParams,
                                            });
                                        };
                                    }
                                });
                            } catch (error) {
                                throw error;
                            }
                        }
                    },
                },
            },
            title: titleData,
            credits: {
                enabled: false,
            },
            series: seriesData,
            exporting: {
                enabled: false,
            },
            xAxis: [
                {
                    type: 'category',
                    startOnTick: true,
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    title: {
                        text: xAxisText,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                } as Highcharts.XAxisOptions,
            ],
            yAxis: [
                {
                    title: {
                        text: yAxisText,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    lineWidth: 1,
                } as Highcharts.YAxisOptions,
            ],
            legend: {
                enabled: true,
            },
            plotOptions: {
                series: {
                    maxPointWidth: 52,
                    groupPadding: 0,
                    lineWidth: 3,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    pointStart: 0,
                    dataGrouping: {
                        enabled: false,
                    },
                    marker: {
                        enabled: true,
                        symbol: 'circle',
                    },
                    cursor: hasDrilldownAccsess ? 'pointer' : 'default',
                    point: {
                        events: {
                            click: function (point) {
                                if (hasDrilldownAccsess) {
                                    _this.router.navigate([drillDownUrl], {
                                        queryParams: {
                                            positionAbbv: this.properties.positionAbbv,
                                            selectedPeriod: this.name,
                                            navFromUrl: navFromUrl,
                                            titleSuffix:
                                                ': ' + this.properties.position + ' ' + this.name,
                                        },
                                    });
                                }
                            },
                        },
                    },
                } as Highcharts.PlotSeriesOptions,
            },
            tooltip: {
                shared: true,
                useHTML: true,
                borderColor: 'white',
                backgroundColor: 'white',
                borderRadius: 7,
                fontFamily: 'Roboto',
                formatter: function (p) {
                    let headCountTotal = 0;
                    let length = this.points.length;
                    return (
                        `<div>
                            <div class="profitability-tooltip-title" style="padding-left: 10px;">
                                <div style="font-size: 14px; font-weight: 700">
                                    ${_this.getToolTiptitle(this.points[0].point.name)}
                                </div>
                            </div>
                        <table style="border-collapse: collapse">
                        ` +
                        this.points.reduce(function (s, point, index) {
                            headCountTotal += point.y;
                            s += `<tr">
                                    <td>
                                       <span style="color:${point.point.color};
                                                   font-size: 40px;
                                                   line-height: 15px;
                                                    ">•</span>
                                    </td>
                                    <td style="display: flex;
                                               padding: 3px 0 3px 0px">
                                        <b>${point.series.name}</b>
                                    </td>
                                    <td style="text-align: right;">
                                        ${_this.reusableFunctions.formatNumber(
                                            point.point.y,
                                            0,
                                            'number'
                                        )}
                                     </td>
                                </tr>`;
                            if (index === length - 1) {
                                s += `<tr>
                                         <td style="border-top: 1px solid #505D6F;"></td>
                                         <td style="
                                             text-align: left;
                                             font-weight: 700;
                                             border-top: 1px solid #505D6F;">
                                             Total
                                         </td>
                                         <td style="
                                             text-align: right;
                                             border-top: 1px solid #505D6F;">
                                             ${_this.reusableFunctions.formatNumber(
                                                 headCountTotal,
                                                 0,
                                                 'number'
                                             )}
                                         </td>
                                     </tr>`;
                            }
                            return s;
                        }, '') +
                        ' </table></div>'
                    );
                },
            } as Highcharts.TooltipOptions,
        };
        return chartOptions;
    } //<div style="height: 2px; border-bottom: 1px solid #505D6F;"></div>

    getToolTiptitle(title: string) {
        let titleParts = title.split('-');
        let monthInfo = this.reusableFunctions.getMonthName(+titleParts[1]);

        return monthInfo.fullMonth + ' ' + titleParts[0];
    }
}
